import { defineMessages } from 'react-intl-next';

export const messages: {
	sources_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sources_title: {
		id: 'search_ai.sources_label',
		// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
		defaultMessage: '{numSources, plural, =1 {Source} other {Sources}}',
		description: 'Label text for the sources section of the AI Answer component',
	},
});
